// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1oPoh","active":"downloadDropdown_active__1DDir"};